<template>
    <div :class="['gap-general strange trading-conditions-events', isHoliday ? '' : 'no-holiday']">
        <SmallBanner
            :icon="'description'"
            :title="$t('trading-conditions-events.titlebanner')"
            :description="$t('trading-conditions-events.descriptbanner')"
        />
        <div class="content_ margin-general">
            <div class="event">
                <div class="forex-trading-hours-table">
                    <div class="title-descript-note">
                        <h3>{{ $t('trading-conditions-events.titleevent') }}</h3>
                        <p class="body-4" v-html="formatContent('trading-conditions-events.descriptevent', $t)"></p>
                    </div>
                    <div class="title-descript-note">
                        <div class="title-desc">
                            <h4 class="body-3-bold">President’s Day – Monday, February 16, 2026</h4>
                        </div>
                        <div class="alert">
                            <span class="material-symbols-outlined" translate="no">error</span>
                            <div class="cont">
                                <p class="body-4">
                                    Please note that in observance of the <strong> President's Day </strong>holiday in the United States,<strong> US equity 
                                    markets will be closed on Monday, February 16th.</strong> Trading will resume during normal market hours on Tuesday, February 17th.
                                </p>
                                <!-- Futures are not offered by Tradeview Europe. -->
                                <p class="body-4">
                                    We recommend reviewing any open positions and remaining aware of potential reduced liquidity during this period.
                                </p>
                            </div>
                        </div>
                        <!-- <div class="alert" v-if="locale === 'es' || locale === 'es-co' || locale === 'es-cl' || locale === 'es-mx' || locale === 'es-ar' || locale === 'es-pe'">
                        </div> -->
                        <!-- <p class="disclaimer" v-html="formatContent('trading-conditions-events.disclaimer', $t, localPath)"> -->
                        <p class="disclaimer">
                            Disclaimer: Times below are in GMT and may be subject to change.
                        </p>
                    </div>
                    <div class="container-table">
                        <div class="table">
                            <table>
                                <thead>
                                </thead>
                                <tbody> 
                                    <tr v-for="(item, index) in times" :key="index">
                                        <td>
                                            <div :class="item[0].class" class="row">
                                                <div class="data date">
                                                    <template v-if="Array.isArray(item[0].date)">
                                                        <div v-for="(date, dateIndex) in item[0].date"
                                                            :key="dateIndex"
                                                            v-html="$te(date) ? $t(date) : date">
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        {{ $te(item[0].date) ? $t(item[0].date) : item[0].date }}
                                                    </template>
                                                </div>
                                                <div class="data hour">
                                                    <template v-if="Array.isArray(item[0].product)">
                                                        <div v-for="(product, productIndex) in item[0].product"
                                                            :key="productIndex"
                                                            v-html="$te(product) ? $t(product) : product">
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        {{ $te(item[0].product) ? $t(item[0].product) : item[0].product }}
                                                    </template>
                                                </div>
                                                <div class="data hours">
                                                    <template v-if="Array.isArray(item[0].hours)">
                                                        <div v-for="(hour, hourIndex) in item[0].hours"
                                                            :key="hourIndex"
                                                            :class="{ 'closed': ($te(hour) ? $t(hour) : hour).includes('Closed') }"
                                                            v-html="$te(hour) ? $t(hour) : hour">
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        {{ $te(item[0].hours) ? $t(item[0].hours) : item[0].hours }}
                                                    </template>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <p class="body-4" v-html="formatContent('trading-conditions-events.disclaimer2', $t)"></p>
                    </div>
                    <div class="links_tradings strategy">
                        <div class="tradingCond">
                            <div class="containerOpt">
                                <p class="title body-6-bold">{{ $t('trading-conditions-events.strategy-title') }}</p>
                                <div class="cont-opt">
                                    <div class="opt">
                                        <div class="icon">
                                            <span class="material-symbols-outlined" translate="no">tactic</span>
                                        </div>
                                        <div>
                                            <p class="body-4" v-html="formatContent('trading-conditions-events.strategy-text1', $t)"></p>
                                        </div>
                                    </div>
                                    <div class="opt">
                                        <div class="icon">
                                            <span class="material-symbols-outlined" translate="no">notifications_active</span>
                                        </div>
                                        <div>
                                            <p class="body-4" v-html="formatContent('trading-conditions-events.strategy-text2', $t)"></p>
                                        </div>
                                    </div>
                                    <div class="opt">
                                        <div class="icon">
                                            <span class="material-symbols-outlined" translate="no">support_agent</span>
                                        </div>
                                        <div>
                                            <p class="body-4" v-html="formatContent('trading-conditions-events.strategy-text3', $t)"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="links_tradings">
                <LazyTradingCond
                    title="Forex"
                    :cards="cardsTradingCond"
                />
                <LazyTradingCond
                    title="Stocks"
                    :cards="cardsTradingCond2"
                />
               <!--  <LazyTradingCond
                    title="Futures"
                    :cards="cardsTradingCond3"
                /> -->
            </div>
        </div>
        <client-only>
            <LazyInvestment
                class="investment var-invest-two"
                :label="'trading-conditions-events.investment'"
                :buttonConfigs="[
                    {
                        type: 'external',
                        href: getExternalUrl('/register/1/live-account'),
                        class: 'primary-button-medium',
                        textKey: 'trading-conditions-events.btn'
                    }
                ]"
            />
        </client-only>
    </div>
</template>
  
<script setup>
import SmallBanner from "~/components/SmallBanner.vue";
import LazyTradingCond from '~/components/trading-conditions.vue';

import { useI18n } from "vue-i18n";

const { getExternalUrl } = useExternalUrl();
const { t } = useI18n();

const title = t("seo.trading-conditions.trading-conditions-events.title");
const description = t("seo.trading-conditions.trading-conditions-events.description");
const imgSeo = 'https://tradeview.eu/images/seo/34Tradingconditions&events.jpg'

useSeoMeta({
    title: title,
    ogTitle: title,
    twitterTitle: title,
    description: description,
    ogDescription: description,
    twitterDescription: description,
    ogImage: imgSeo,
    twitterImage: imgSeo
});

const times = [
    [
        {  
            date: 'Date',
            product: "Products affected", 
            hours: "Trading Hours", 
            class: "bold back" 
        },
    ],
    [
        { 
            date: ["16/02/2026"],
            product: ["Natural Gas. US Crude Oil"],
            hours: [
                "23:00 Sun – 19:15 Mon"
            ],
        },
    ],
    [
        { 
             date: ["16/02/2026"],
            product: ["Gold, Silver"],
            hours: [
                "23:00 Sun – 19:30 Mon"
            ], 
        },
    ],
    [
        { 
             date: ["16/02/2026"],
            product: ["UK Brent Oil"],
            hours: [
                "01:00 – 19:15"
            ],
        },
    ],
    [
        { 
             date: ["16/02/2026"],
            product: ["Japan 225, Wall Street 30, US SPX 500, US Tech 100"],
            hours: [
                "23:00 Sun – 18:00 Mon"
            ],
        },
    ],
    [
        { 
             date: ["16/02/2026"],
            product: ["Australia 200, France 40, Europe 50, Germany 40, UK 100"],
            hours: [
                "23:00 Sun – 21:00 Mon"
            ],
        },
    ]
];


let cardsTradingCond = ref([
    {
        icon: "contract",
        title: "trading-conditions-events.title1",
        description: "trading-conditions-events.descript1",
        link: "trading-conditions-events.link1",
        url: "/trading/markets/trading-conditions/forex-contract-specs",
    },
    {
        icon: "cached",
        title: "trading-conditions-events.title2",
        description: "trading-conditions-events.descript2",
        link: "trading-conditions-events.link2",
        url: "/trading/markets/trading-conditions/forex-rollover-rates",
    },
    {
        icon: "event",
        title: "trading-conditions-events.title3",
        description: "trading-conditions-events.descript3",
        link: "trading-conditions-events.link3",
        url: "/trading/markets/trading-conditions/order-types",
    },
]);

let cardsTradingCond2 = ref([
    {
        icon: "article",
        title: "trading-conditions-events.title4",
        description: "trading-conditions-events.descript4",
        link: "trading-conditions-events.link4",
        url: "/trading/markets/trading-conditions/stocks-trading-hours/",
    },
    {
        icon: "event",
        title: "trading-conditions-events.title3",
        description: "trading-conditions-events.descript3",
        link: "trading-conditions-events.link3stock",
        url: "/trading/markets/trading-conditions/order-types/",
    },
]);

/* let cardsTradingCond3 = ref([
    {
        icon: "contract",
        title: "trading-conditions-events.title1",
        description: "trading-conditions-events.descript1",
        link: "trading-conditions-events.link1",
        url: "/trading/markets/trading-conditions/futures-contract-specs",
    },
    {
        icon: "percent",
        title: "trading-conditions-events.title6",
        description: "trading-conditions-events.descript6",
        link: "trading-conditions-events.link6",
        url: "/trading/markets/trading-conditions/futures-margin-requirements",
    },
    {
        icon: "alarm",
        title: "trading-conditions-events.title7",
        description: "trading-conditions-events.descript4",
        link: "trading-conditions-events.link4",
        url: "/trading/markets/trading-conditions/futures-trading-hours",
    },
]); */

const isHoliday = ref(false);

const getNowInLosAngeles = () => {
  return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
};

const holidayStart = new Date('2026-02-16T08:30:00'); 
const holidayEnd = new Date('2026-02-16T23:59:59'); 

const checkHoliday = () => {
  const nowInLosAngeles = getNowInLosAngeles();

  isHoliday.value = nowInLosAngeles >= holidayStart && nowInLosAngeles <= holidayEnd;
  console.log('isHoliday:', isHoliday.value);
};

onMounted(() => {
  checkHoliday();
});
</script>
